import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const enableInstaller = ({ id_installer, token: { access } }) =>
  Manager.client(access).post(Endpoints.users.enableInstaller, {
    id_installer,
  });

const enableCustomer = ({ id_customer, token: { access } }) =>
  Manager.client(access).post(Endpoints.users.enableCustomer, { id_customer });

const enableSupport = ({ id_support, token: { access } }) =>
  Manager.client(access).post(Endpoints.users.enableSupport, { id_support });

export const Request = {
  enableInstaller,
  enableCustomer,
  enableSupport,
};
